import PropTypes from 'prop-types';
import React from 'react';
import ScrollInView from '@utility/ScrollInView/index';

const Quote = ({ data: { quote, author, role } }) => (
  <ScrollInView>
    <div className="wrapper">
      <div className="row">
        <div className="col-12 md:col-8 md:offset-2">
          <blockquote className="has-delay-container">
            <p className="has-delay type-sans-530 md:type-sans-730">{quote}</p>
            {(author || role) && (
              <cite className="has-delay mt-6">
                <p className="type-sans-240">{author}</p>
                <p className="type-sans-230">{role}</p>
              </cite>
            )}
          </blockquote>
        </div>
      </div>
    </div>
  </ScrollInView>
);

Quote.propTypes = {
  data: PropTypes.shape({
    quote: PropTypes.string.isRequired,
    author: PropTypes.string,
    role: PropTypes.string,
  }),
};

Quote.defaultProps = {
  data: {
    author: '',
    role: '',
  },
};

export default Quote;
